export default __webpack_public_path__ + "static/media/direction-ltr.20a56597.svg";